/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccuracyRouteImport } from './routes/_app/accuracy'
import { Route as AppAnnouncementsRouteImport } from './routes/_app/announcements'
import { Route as AppAuditLogRouteImport } from './routes/_app/audit-log'
import { Route as AppBillingPlansRouteImport } from './routes/_app/billing-plans'
import { Route as AppCouponsRouteImport } from './routes/_app/coupons'
import { Route as AppCreditPacksRouteImport } from './routes/_app/credit-packs'
import { Route as AppEmailTemplatesRouteImport } from './routes/_app/email-templates'
import { Route as AppLedgerRouteImport } from './routes/_app/ledger'
import { Route as AppLessonsRouteImport } from './routes/_app/lessons'
import { Route as AppOffersRouteImport } from './routes/_app/offers'
import { Route as AppReferencePricesRouteImport } from './routes/_app/reference-prices'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthSetPasswordRouteImport } from './routes/_auth/set-password'
import { Route as AppPeopleIndexRouteImport } from './routes/_app/people/index'
import { Route as AppPeopleIdRouteImport } from './routes/_app/people/$id'
import { Route as AppStaffIndexRouteImport } from './routes/_app/staff/index'
import { Route as AppStaffIdRouteImport } from './routes/_app/staff/$id'
import { Route as AppSupportIndexRouteImport } from './routes/_app/support/index'
import { Route as AppSupportMineRouteImport } from './routes/_app/support/mine'
import { Route as AppYardsIndexRouteImport } from './routes/_app/yards/index'
import { Route as AppYardsIdRouteImport } from './routes/_app/yards/$id'
import { Route as AppHelpArticlesIndexRouteImport } from './routes/_app/help/articles/index'
import { Route as AppHelpArticlesIdRouteImport } from './routes/_app/help/articles/$id'
import { Route as AppHelpArticlesNewRouteImport } from './routes/_app/help/articles/new'
import { Route as AppSupportTicketsIdRouteImport } from './routes/_app/support/tickets.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccuracyRoute = AppAccuracyRouteImport.update({
  id: '/accuracy',
  path: '/accuracy',
  getParentRoute: () => AppRoute,
} as any)
const AppAnnouncementsRoute = AppAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditLogRoute = AppAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingPlansRoute = AppBillingPlansRouteImport.update({
  id: '/billing-plans',
  path: '/billing-plans',
  getParentRoute: () => AppRoute,
} as any)
const AppCouponsRoute = AppCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => AppRoute,
} as any)
const AppCreditPacksRoute = AppCreditPacksRouteImport.update({
  id: '/credit-packs',
  path: '/credit-packs',
  getParentRoute: () => AppRoute,
} as any)
const AppEmailTemplatesRoute = AppEmailTemplatesRouteImport.update({
  id: '/email-templates',
  path: '/email-templates',
  getParentRoute: () => AppRoute,
} as any)
const AppLedgerRoute = AppLedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => AppRoute,
} as any)
const AppLessonsRoute = AppLessonsRouteImport.update({
  id: '/lessons',
  path: '/lessons',
  getParentRoute: () => AppRoute,
} as any)
const AppOffersRoute = AppOffersRouteImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => AppRoute,
} as any)
const AppReferencePricesRoute = AppReferencePricesRouteImport.update({
  id: '/reference-prices',
  path: '/reference-prices',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppPeopleIndexRoute = AppPeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleIdRoute = AppPeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffIndexRoute = AppStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffIdRoute = AppStaffIdRouteImport.update({
  id: '/staff/$id',
  path: '/staff/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportIndexRoute = AppSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportMineRoute = AppSupportMineRouteImport.update({
  id: '/support/mine',
  path: '/support/mine',
  getParentRoute: () => AppRoute,
} as any)
const AppYardsIndexRoute = AppYardsIndexRouteImport.update({
  id: '/yards/',
  path: '/yards/',
  getParentRoute: () => AppRoute,
} as any)
const AppYardsIdRoute = AppYardsIdRouteImport.update({
  id: '/yards/$id',
  path: '/yards/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpArticlesIndexRoute = AppHelpArticlesIndexRouteImport.update({
  id: '/help/articles/',
  path: '/help/articles/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpArticlesIdRoute = AppHelpArticlesIdRouteImport.update({
  id: '/help/articles/$id',
  path: '/help/articles/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpArticlesNewRoute = AppHelpArticlesNewRouteImport.update({
  id: '/help/articles/new',
  path: '/help/articles/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportTicketsIdRoute = AppSupportTicketsIdRouteImport.update({
  id: '/support/tickets/$id',
  path: '/support/tickets/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/accuracy': typeof AppAccuracyRoute
  '/announcements': typeof AppAnnouncementsRoute
  '/audit-log': typeof AppAuditLogRoute
  '/billing-plans': typeof AppBillingPlansRoute
  '/coupons': typeof AppCouponsRoute
  '/credit-packs': typeof AppCreditPacksRoute
  '/email-templates': typeof AppEmailTemplatesRoute
  '/ledger': typeof AppLedgerRoute
  '/lessons': typeof AppLessonsRoute
  '/offers': typeof AppOffersRoute
  '/reference-prices': typeof AppReferencePricesRoute
  '/settings': typeof AppSettingsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/people/$id': typeof AppPeopleIdRoute
  '/staff/$id': typeof AppStaffIdRoute
  '/support/mine': typeof AppSupportMineRoute
  '/yards/$id': typeof AppYardsIdRoute
  '/people/': typeof AppPeopleIndexRoute
  '/staff/': typeof AppStaffIndexRoute
  '/support/': typeof AppSupportIndexRoute
  '/yards/': typeof AppYardsIndexRoute
  '/help/articles/$id': typeof AppHelpArticlesIdRoute
  '/help/articles/new': typeof AppHelpArticlesNewRoute
  '/support/tickets/$id': typeof AppSupportTicketsIdRoute
  '/help/articles/': typeof AppHelpArticlesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/accuracy': typeof AppAccuracyRoute
  '/announcements': typeof AppAnnouncementsRoute
  '/audit-log': typeof AppAuditLogRoute
  '/billing-plans': typeof AppBillingPlansRoute
  '/coupons': typeof AppCouponsRoute
  '/credit-packs': typeof AppCreditPacksRoute
  '/email-templates': typeof AppEmailTemplatesRoute
  '/ledger': typeof AppLedgerRoute
  '/lessons': typeof AppLessonsRoute
  '/offers': typeof AppOffersRoute
  '/reference-prices': typeof AppReferencePricesRoute
  '/settings': typeof AppSettingsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/people/$id': typeof AppPeopleIdRoute
  '/staff/$id': typeof AppStaffIdRoute
  '/support/mine': typeof AppSupportMineRoute
  '/yards/$id': typeof AppYardsIdRoute
  '/people': typeof AppPeopleIndexRoute
  '/staff': typeof AppStaffIndexRoute
  '/support': typeof AppSupportIndexRoute
  '/yards': typeof AppYardsIndexRoute
  '/help/articles/$id': typeof AppHelpArticlesIdRoute
  '/help/articles/new': typeof AppHelpArticlesNewRoute
  '/support/tickets/$id': typeof AppSupportTicketsIdRoute
  '/help/articles': typeof AppHelpArticlesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/accuracy': typeof AppAccuracyRoute
  '/_app/announcements': typeof AppAnnouncementsRoute
  '/_app/audit-log': typeof AppAuditLogRoute
  '/_app/billing-plans': typeof AppBillingPlansRoute
  '/_app/coupons': typeof AppCouponsRoute
  '/_app/credit-packs': typeof AppCreditPacksRoute
  '/_app/email-templates': typeof AppEmailTemplatesRoute
  '/_app/ledger': typeof AppLedgerRoute
  '/_app/lessons': typeof AppLessonsRoute
  '/_app/offers': typeof AppOffersRoute
  '/_app/reference-prices': typeof AppReferencePricesRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/set-password': typeof AuthSetPasswordRoute
  '/_app/': typeof AppIndexRoute
  '/_app/people/$id': typeof AppPeopleIdRoute
  '/_app/staff/$id': typeof AppStaffIdRoute
  '/_app/support/mine': typeof AppSupportMineRoute
  '/_app/yards/$id': typeof AppYardsIdRoute
  '/_app/people/': typeof AppPeopleIndexRoute
  '/_app/staff/': typeof AppStaffIndexRoute
  '/_app/support/': typeof AppSupportIndexRoute
  '/_app/yards/': typeof AppYardsIndexRoute
  '/_app/help/articles/$id': typeof AppHelpArticlesIdRoute
  '/_app/help/articles/new': typeof AppHelpArticlesNewRoute
  '/_app/support/tickets/$id': typeof AppSupportTicketsIdRoute
  '/_app/help/articles/': typeof AppHelpArticlesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accuracy'
    | '/announcements'
    | '/audit-log'
    | '/billing-plans'
    | '/coupons'
    | '/credit-packs'
    | '/email-templates'
    | '/ledger'
    | '/lessons'
    | '/offers'
    | '/reference-prices'
    | '/settings'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/people/$id'
    | '/staff/$id'
    | '/support/mine'
    | '/yards/$id'
    | '/people/'
    | '/staff/'
    | '/support/'
    | '/yards/'
    | '/help/articles/$id'
    | '/help/articles/new'
    | '/support/tickets/$id'
    | '/help/articles/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accuracy'
    | '/announcements'
    | '/audit-log'
    | '/billing-plans'
    | '/coupons'
    | '/credit-packs'
    | '/email-templates'
    | '/ledger'
    | '/lessons'
    | '/offers'
    | '/reference-prices'
    | '/settings'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/people/$id'
    | '/staff/$id'
    | '/support/mine'
    | '/yards/$id'
    | '/people'
    | '/staff'
    | '/support'
    | '/yards'
    | '/help/articles/$id'
    | '/help/articles/new'
    | '/support/tickets/$id'
    | '/help/articles'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_app/accuracy'
    | '/_app/announcements'
    | '/_app/audit-log'
    | '/_app/billing-plans'
    | '/_app/coupons'
    | '/_app/credit-packs'
    | '/_app/email-templates'
    | '/_app/ledger'
    | '/_app/lessons'
    | '/_app/offers'
    | '/_app/reference-prices'
    | '/_app/settings'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/set-password'
    | '/_app/'
    | '/_app/people/$id'
    | '/_app/staff/$id'
    | '/_app/support/mine'
    | '/_app/yards/$id'
    | '/_app/people/'
    | '/_app/staff/'
    | '/_app/support/'
    | '/_app/yards/'
    | '/_app/help/articles/$id'
    | '/_app/help/articles/new'
    | '/_app/support/tickets/$id'
    | '/_app/help/articles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accuracy': {
      id: '/_app/accuracy'
      path: '/accuracy'
      fullPath: '/accuracy'
      preLoaderRoute: typeof AppAccuracyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/announcements': {
      id: '/_app/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AppAnnouncementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit-log': {
      id: '/_app/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AppAuditLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing-plans': {
      id: '/_app/billing-plans'
      path: '/billing-plans'
      fullPath: '/billing-plans'
      preLoaderRoute: typeof AppBillingPlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coupons': {
      id: '/_app/coupons'
      path: '/coupons'
      fullPath: '/coupons'
      preLoaderRoute: typeof AppCouponsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/credit-packs': {
      id: '/_app/credit-packs'
      path: '/credit-packs'
      fullPath: '/credit-packs'
      preLoaderRoute: typeof AppCreditPacksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/email-templates': {
      id: '/_app/email-templates'
      path: '/email-templates'
      fullPath: '/email-templates'
      preLoaderRoute: typeof AppEmailTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ledger': {
      id: '/_app/ledger'
      path: '/ledger'
      fullPath: '/ledger'
      preLoaderRoute: typeof AppLedgerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lessons': {
      id: '/_app/lessons'
      path: '/lessons'
      fullPath: '/lessons'
      preLoaderRoute: typeof AppLessonsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offers': {
      id: '/_app/offers'
      path: '/offers'
      fullPath: '/offers'
      preLoaderRoute: typeof AppOffersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reference-prices': {
      id: '/_app/reference-prices'
      path: '/reference-prices'
      fullPath: '/reference-prices'
      preLoaderRoute: typeof AppReferencePricesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/set-password': {
      id: '/_auth/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof AuthSetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/people/': {
      id: '/_app/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof AppPeopleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people/$id': {
      id: '/_app/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof AppPeopleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff/': {
      id: '/_app/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof AppStaffIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff/$id': {
      id: '/_app/staff/$id'
      path: '/staff/$id'
      fullPath: '/staff/$id'
      preLoaderRoute: typeof AppStaffIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/': {
      id: '/_app/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AppSupportIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/mine': {
      id: '/_app/support/mine'
      path: '/support/mine'
      fullPath: '/support/mine'
      preLoaderRoute: typeof AppSupportMineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/yards/': {
      id: '/_app/yards/'
      path: '/yards'
      fullPath: '/yards/'
      preLoaderRoute: typeof AppYardsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/yards/$id': {
      id: '/_app/yards/$id'
      path: '/yards/$id'
      fullPath: '/yards/$id'
      preLoaderRoute: typeof AppYardsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/articles/': {
      id: '/_app/help/articles/'
      path: '/help/articles'
      fullPath: '/help/articles/'
      preLoaderRoute: typeof AppHelpArticlesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/articles/$id': {
      id: '/_app/help/articles/$id'
      path: '/help/articles/$id'
      fullPath: '/help/articles/$id'
      preLoaderRoute: typeof AppHelpArticlesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/articles/new': {
      id: '/_app/help/articles/new'
      path: '/help/articles/new'
      fullPath: '/help/articles/new'
      preLoaderRoute: typeof AppHelpArticlesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/tickets/$id': {
      id: '/_app/support/tickets/$id'
      path: '/support/tickets/$id'
      fullPath: '/support/tickets/$id'
      preLoaderRoute: typeof AppSupportTicketsIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccuracyRoute: typeof AppAccuracyRoute
  AppAnnouncementsRoute: typeof AppAnnouncementsRoute
  AppAuditLogRoute: typeof AppAuditLogRoute
  AppBillingPlansRoute: typeof AppBillingPlansRoute
  AppCouponsRoute: typeof AppCouponsRoute
  AppCreditPacksRoute: typeof AppCreditPacksRoute
  AppEmailTemplatesRoute: typeof AppEmailTemplatesRoute
  AppLedgerRoute: typeof AppLedgerRoute
  AppLessonsRoute: typeof AppLessonsRoute
  AppOffersRoute: typeof AppOffersRoute
  AppReferencePricesRoute: typeof AppReferencePricesRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPeopleIdRoute: typeof AppPeopleIdRoute
  AppStaffIdRoute: typeof AppStaffIdRoute
  AppSupportMineRoute: typeof AppSupportMineRoute
  AppYardsIdRoute: typeof AppYardsIdRoute
  AppPeopleIndexRoute: typeof AppPeopleIndexRoute
  AppStaffIndexRoute: typeof AppStaffIndexRoute
  AppSupportIndexRoute: typeof AppSupportIndexRoute
  AppYardsIndexRoute: typeof AppYardsIndexRoute
  AppHelpArticlesIdRoute: typeof AppHelpArticlesIdRoute
  AppHelpArticlesNewRoute: typeof AppHelpArticlesNewRoute
  AppSupportTicketsIdRoute: typeof AppSupportTicketsIdRoute
  AppHelpArticlesIndexRoute: typeof AppHelpArticlesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccuracyRoute: AppAccuracyRoute,
  AppAnnouncementsRoute: AppAnnouncementsRoute,
  AppAuditLogRoute: AppAuditLogRoute,
  AppBillingPlansRoute: AppBillingPlansRoute,
  AppCouponsRoute: AppCouponsRoute,
  AppCreditPacksRoute: AppCreditPacksRoute,
  AppEmailTemplatesRoute: AppEmailTemplatesRoute,
  AppLedgerRoute: AppLedgerRoute,
  AppLessonsRoute: AppLessonsRoute,
  AppOffersRoute: AppOffersRoute,
  AppReferencePricesRoute: AppReferencePricesRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppPeopleIdRoute: AppPeopleIdRoute,
  AppStaffIdRoute: AppStaffIdRoute,
  AppSupportMineRoute: AppSupportMineRoute,
  AppYardsIdRoute: AppYardsIdRoute,
  AppPeopleIndexRoute: AppPeopleIndexRoute,
  AppStaffIndexRoute: AppStaffIndexRoute,
  AppSupportIndexRoute: AppSupportIndexRoute,
  AppYardsIndexRoute: AppYardsIndexRoute,
  AppHelpArticlesIdRoute: AppHelpArticlesIdRoute,
  AppHelpArticlesNewRoute: AppHelpArticlesNewRoute,
  AppSupportTicketsIdRoute: AppSupportTicketsIdRoute,
  AppHelpArticlesIndexRoute: AppHelpArticlesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
